import Capture from "../Capture";
import QrScanner from "../common/Html5QrcodeScannerComponent";
import { useEffect, useState } from "react";

import halfGalzedImg from "../../assets/img/halfGlazed.jpg";
import acrylicWindowImg from "../../assets/img/acrylicWindow.jpg";
import fullGlazedImg from "../../assets/img/fullGlazed.jpg";
import glazedVisionPanelImg from "../../assets/img/glazedVisionPanel.jpg";
import DatePicker from "react-datepicker";

const BasicInformationSection = (props) => {
  const {
    mandatoryFieldRef,
    formData,
    basicFormData,
    handleBuildingName,
    handleChange,
    handleImagesChange,
    handleDeleteImages,
    resetCaptureFlag,
    handleFormDataChange,
    doorTypesOption,
    doorConfigurationsOption,
    doorOtherFlag,
    ShowScanQRCode,
    OnsetShowScanQRCode,
    generateQRCode,
    isView,
    doorColorOtherFlag,
    doorMaterialOtherFlag,
  } = props;

  const doorGlazingOptions = [
    { id: 1, img: halfGalzedImg, label: "Half Glazed" },
    { id: 2, img: acrylicWindowImg, label: "Acrylic Window" },
    { id: 3, img: fullGlazedImg, label: "Full Glazed" },
    { id: 4, img: glazedVisionPanelImg, label: "Glazed Vision Panel" },
  ];
  const [selectedDoorGlaze, setSelectedDoorGlaze] = useState(null);

  useEffect(() => {
    const id =
      formData.GlazingDoor === "No"
        ? null
        : formData.glazingDoorLabel === ""
          ? null
          : doorGlazingOptions.filter(
              (option) => option.label === formData.glazingDoorLabel,
            )[0]?.id || null;
    setSelectedDoorGlaze(id);
  }, [formData]);

  return (
    <>
      <div className="card mb-4">
        <div className="card-body">
          <div className="col-sm-12">
            <p className="fs-6 fw-semibold">Basic Information</p>
          </div>

          <div className="form-floating mb-3">
            <input
              type="text"
              className="form-control"
              id="buildingName"
              name="buildingName"
              disabled
              placeholder="Jesmond Newcastle"
              value={basicFormData.buildingName}
              onChange={handleBuildingName}
            />
            <label htmlFor="buildingName">Building Name</label>
          </div>

          <div className="form-floating mb-3">
            <input
              type="text"
              className="form-control"
              id="uniqueRef"
              name="uniqueRef"
              disabled
              placeholder="JN1234"
              value={basicFormData.uniqueRef}
            />
            <label htmlFor="uniqueRef">Unique Building Reference</label>
          </div>

          {/* <div className="form-floating mb-3">
            <input
              type="date"
              className="form-control"
              id="date"
              name="date"
              disabled={isView}
              value={basicFormData.date}
              onChange={(e) => handleChange(e)}
            />
            <label htmlFor="date">Date</label>
          </div> */}

          <div
            className="form-floating mb-3"
            style={{ position: "relative", width: "100%" }}
          >
            <DatePicker
              selected={
                basicFormData.date ? new Date(basicFormData.date) : null
              }
              onChange={(date) =>
                handleChange({
                  // target: {
                  //   value: date ? date.toISOString().split("T")[0] : "",
                  //   name: "date"
                  // },
                  target: {
                    name: "date",
                    value: date
                      ? `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`
                      : "",
                  },
                })
              }
              // onChange={(e) => handleChange(e)}
              disabled={isView}
              name="date"
              minDate={new Date()}
              dateFormat="MM-dd-yy"
              placeholderText=" "
              id="date"
              customInput={
                <input
                  className="form-control"
                  style={{
                    height: "calc(3.5rem + 2px)",
                    padding: "1.625rem 0.75rem 1rem 0.75rem",
                    width: "100%",
                  }}
                />
              }
            />

            <label
              htmlFor="date"
              style={{
                position: "absolute",
                top: "0",
                left: "0",
                height: "100%",
                // padding: "1rem 0.75rem",
                padding: "0.75rem 0.75rem",
                pointerEvents: "none",
                transformOrigin: "0 0",
                transition: "all 0.2s ease",
                opacity: basicFormData.date ? 0.65 : 1,
                transform: basicFormData.date
                  ? "scale(0.85) translateY(-0.5rem) translateX(0.15rem)"
                  : "none",
              }}
            >
              Date <span style={{ color: "red" }}>*</span>
            </label>
          </div>

          <div className="form-floating mb-3">
            <textarea
              className="form-control"
              rows="5"
              disabled
              style={{ minHeight: "auto", height: "auto" }}
              placeholder="Location"
              id="location"
              name="location"
              onChange={(e) => handleChange(e)}
              value={basicFormData.location}
            ></textarea>
            <label htmlFor="location">Location</label>
          </div>

          <div className="form-floating mb-3">
            <input
              ref={(el) => (mandatoryFieldRef.current.floor = el)}
              type="number"
              pattern="[0-9]*"
              inputMode="numeric"
              step={1}
              onKeyDown={(e) => {
                if (e.key === "e" || e.key === ".") {
                  e.preventDefault(); // Prevent invalid characters
                }
              }}
              className="form-control"
              id="floor"
              name="floor"
              value={basicFormData.floor}
              placeholder="12"
              disabled={isView}
              onChange={(e) => handleChange(e)}
            />
            <label htmlFor="floor">
              Floor<span style={{ color: "red" }}>*</span>
            </label>
          </div>

          <div className="form-floating mb-3">
            <div className="d-flex gap-3 flex-wrap">
              <label htmlFor="floorPlan">
                {isView ? "Floor Plan" : "Upload Floor Plan"}
              </label>
              <Capture
                isView={isView}
                savedImages={basicFormData.floorPlan}
                onImagesChange={(images) => handleImagesChange(images, "Floor")}
                reset={resetCaptureFlag}
                onImageDelete={(index) => handleDeleteImages(index, "Floor")}
                mandatoryFieldRef={mandatoryFieldRef}
                fieldValue={"floorFile"}
                singleImageCapture
                allowPdf={true}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="card">
        <div className="card-body">
          <div className="col-sm-12">
            <p className="fs-6 fw-semibold">Door Information</p>
          </div>
          <div className="form-floating mb-3">
            <input
              type="text"
              ref={(el) => (mandatoryFieldRef.current.doorLocation = el)}
              className="form-control"
              id="floatingInputValue"
              name="doorLocation"
              value={formData.doorLocation}
              disabled={isView}
              onChange={(e) => {
                handleFormDataChange(e);
              }}
            />
            <label htmlFor="floatingInputValue">
              Door Location<span style={{ color: "red" }}>*</span>
            </label>
          </div>
          <div className="form-floating mb-3">
            <input
              type="text"
              className="form-control"
              id="floatingInputValue"
              name="doorNumber"
              disabled
              value={formData.doorNumber}
            />
            <label htmlFor="floatingInputValue">Door Number</label>
          </div>
          <div className="form-floating mb-3">
            <select
              ref={(el) => (mandatoryFieldRef.current.doorConfiguration = el)}
              className="form-select"
              name="doorConfiguration"
              id="floatingSelect"
              aria-label="Floating label select example"
              value={formData.doorConfiguration}
              disabled={isView}
              onChange={(e) => {
                e.preventDefault();
                handleFormDataChange(e);
              }}
            >
              <option value="Select">Select</option>
              {doorConfigurationsOption?.map((type) => (
                <option
                  key={type.configurationName}
                  value={type.doorConfigurationId}
                >
                  {type.configurationName}
                </option>
              ))}
            </select>
            <label htmlFor="floatingSelect">
              Door Configuration<span style={{ color: "red" }}>*</span>
            </label>
          </div>
          <div className="form-floating mb-3">
            <select
              ref={(el) => (mandatoryFieldRef.current.doorType = el)}
              className="form-select"
              name="doorType"
              id="floatingSelect"
              aria-label="Floating label select example"
              value={formData.doorType}
              disabled={isView}
              onChange={(e) => {
                e.preventDefault();
                handleFormDataChange(e);
              }}
            >
              <option value="Select">Select</option>
              {doorTypesOption?.map((type) => (
                <option key={type.doorTypeName} value={type.doorTypeId}>
                  {type.doorTypeName}
                </option>
              ))}
            </select>
            <label htmlFor="floatingSelect">
              Door Type<span style={{ color: "red" }}>*</span>
            </label>
          </div>
          {doorOtherFlag && (
            <div className="form-floating mb-3">
              <input
                type="text"
                ref={(el) => (mandatoryFieldRef.current.doorOther = el)}
                className="form-control"
                id="floatingInputValue"
                name="doorOther"
                value={formData.doorOther}
                disabled={isView}
                onChange={(e) => {
                  handleFormDataChange(e);
                }}
              />
              <label htmlFor="floatingInputValue">
                Other<span style={{ color: "red" }}>*</span>
              </label>
            </div>
          )}
          <div className="form-floating mb-3">
            <select
              ref={(el) => (mandatoryFieldRef.current.doorColor = el)}
              className="form-select"
              name="doorColor"
              id="floatingSelect"
              aria-label="Floating label select example"
              value={formData.doorColor}
              disabled={isView}
              onChange={(e) => {
                handleFormDataChange(e);
              }}
            >
              <option selected>Select</option>
              <option value={"Oak"}>Oak</option>
              <option value={"Walnut"}>Walnut</option>
              <option value={"White"}>White</option>
              <option value={"Other"}>Other</option>
            </select>
            <label htmlFor="floatingSelect">
              Door Color<span style={{ color: "red" }}>*</span>
            </label>
          </div>
          {doorColorOtherFlag && (
            <div className="form-floating mb-3">
              <input
                type="text"
                ref={(el) => (mandatoryFieldRef.current.doorColorOther = el)}
                className="form-control"
                id="floatingInputValue"
                name="doorColorOther"
                value={formData.doorColorOther}
                disabled={isView}
                onChange={(e) => {
                  handleFormDataChange(e);
                }}
              />
              <label htmlFor="floatingInputValue">
                Door Color Other<span style={{ color: "red" }}>*</span>
              </label>
            </div>
          )}
          <div className="form-floating mb-3">
            <select
              ref={(el) => (mandatoryFieldRef.current.doorMaterial = el)}
              className="form-select"
              name="doorMaterial"
              id="floatingSelect"
              aria-label="Floating label select example"
              value={formData.doorMaterial}
              disabled={isView}
              onChange={(e) => {
                handleFormDataChange(e);
              }}
            >
              <option selected>Select</option>
              <option value={"Steel"}>Steel</option>
              <option value={"Wood"}>Wood</option>
              <option value={"Other"}>Other</option>
            </select>
            <label htmlFor="floatingSelect">
              Door Material<span style={{ color: "red" }}>*</span>
            </label>
          </div>
          {doorMaterialOtherFlag && (
            <div className="form-floating mb-3">
              <input
                type="text"
                ref={(el) => (mandatoryFieldRef.current.doorMaterialOther = el)}
                className="form-control"
                id="floatingInputValue"
                name="doorMaterialOther"
                value={formData.doorMaterialOther}
                disabled={isView}
                onChange={(e) => {
                  handleFormDataChange(e);
                }}
              />
              <label htmlFor="floatingInputValue">
                Door Material Other<span style={{ color: "red" }}>*</span>
              </label>
            </div>
          )}
          <div className="form-floating mb-3">
            <select
              ref={(el) => (mandatoryFieldRef.current.GlazingDoor = el)}
              className="form-select"
              name="GlazingDoor"
              id="floatingSelect"
              aria-label="Floating label select example"
              value={formData.GlazingDoor}
              disabled={isView}
              onChange={(e) => {
                handleFormDataChange(e);
              }}
            >
              <option selected>Select</option>
              <option value={"Yes"}>Yes</option>
              <option value={"No"}>No</option>
            </select>
            <label htmlFor="floatingSelect">
              Door Glazing<span style={{ color: "red" }}>*</span>
            </label>
          </div>
          {formData.GlazingDoor === "Yes" && (
            <div className="form-floating mb-3 d-flex flex-row gap-1 flex-wrap align-items-center justify-content-center">
              {doorGlazingOptions?.map((option, index) => {
                const refname = `glazingDoorLabel${index}`;
                return (
                  <div
                    key={index}
                    ref={(el) => (mandatoryFieldRef.current[refname] = el)}
                    style={{
                      border:
                        selectedDoorGlaze === option.id
                          ? "2px solid #1976d2"
                          : "1px solid #ccc",
                      borderRadius: "8px",
                      padding: "4px",
                      cursor: "pointer",
                      backgroundColor:
                        selectedDoorGlaze === option.id ? "#e3f2fd" : "#fff",
                      width: "23%",
                      textAlign: "center",
                    }}
                    onClick={
                      isView
                        ? () => {}
                        : () => {
                            // let updatedOptions = doorGlazingOptions.map(
                            //   (opt, idx) => ({ ...opt, isSelected: idx === index })
                            // );
                            //setDoorGlazingOptions(updatedOptions);
                            setSelectedDoorGlaze(option.id);
                            handleFormDataChange({
                              target: {
                                name: "glazingDoorLabel",
                                value: option.label,
                              },
                            });
                          }
                    }
                  >
                    <img
                      style={{
                        width: "100%",
                        height: "100px",
                        objectFit: "cover",
                        borderRadius: "4px",
                      }}
                      src={option.img}
                      alt="Background"
                      className="img-fluid"
                    />
                    <div
                      style={{
                        height: "50px",
                        fontWeight: "bold",
                        fontSize: "12px",
                        marginTop: "2px",
                      }}
                      // className="floorplan-floor-number"
                    >
                      {option.label}
                    </div>
                  </div>
                );
              })}
            </div>
          )}
          <div className="form-floating mb-3">
            <div className="d-flex gap-3 flex-wrap">
              <label htmlFor="floorPlan">
                {isView ? "Door Photo" : "Upload Door Photo"}
                <span style={{ color: "red" }}>*</span>
              </label>
              <br></br>
              <Capture
                savedImages={formData.doorPhotos}
                isView={isView}
                onImagesChange={(images) => handleImagesChange(images, "Door")}
                reset={resetCaptureFlag}
                onImageDelete={(index) => handleDeleteImages(index, "Door")}
                mandatoryFieldRef={mandatoryFieldRef}
                fieldValue={"doorFile"}
                singleImageCapture
                allowPdf={false}
              />
            </div>
          </div>
          <div className="col-sm-12">
            <div className="col-12 d-flex gap-3 flex-wrap">
              <button
                type="button"
                className="btn btn-secondary w-auto w-100 flex-grow-1"
                onClick={() => generateQRCode()}
                disabled={isView}
              >
                Generate QR Code
              </button>
              <button
                type="button"
                className="btn btn-secondary w-auto w-100 flex-grow-1"
                onClick={() => OnsetShowScanQRCode(!ShowScanQRCode)}
                disabled={isView}
              >
                {ShowScanQRCode ? "Close Scan QR Code" : "Scan QR Code"}
              </button>
              {ShowScanQRCode && <QrScanner renderInComponent={true} />}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default BasicInformationSection;
